/* Date parsing helpers for backend timestamps rendered in the browser locale. */

export function parseServerDate(value) {
  // Flask often serializes naive timestamps, so treat bare strings as UTC.
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  const normalizedValue =
    typeof value === "string" && !/[zZ]|[+-]\d{2}:\d{2}$/.test(value)
      ? `${value}Z`
      : value;

  const parsedDate = new Date(normalizedValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatLocalDateTime(value) {
  // Used for detailed history/review labels.
  const parsedDate = parseServerDate(value);
  return parsedDate ? parsedDate.toLocaleString() : "—";
}

export function formatLocalTime(value) {
  // Used for compact sidebar/history summaries.
  const parsedDate = parseServerDate(value);
  return parsedDate
    ? parsedDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "";
}

export function formatLocalDateKey(value) {
  // Used as the stable key/value format for date filter controls.
  const parsedDate = parseServerDate(value);
  if (!parsedDate) {
    return "";
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
